import { render, staticRenderFns } from "./ResultsCollaborationModal.vue?vue&type=template&id=7b9f5b40&"
import script from "./ResultsCollaborationModal.vue?vue&type=script&lang=js&"
export * from "./ResultsCollaborationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports